export default __webpack_public_path__ + "static/metasla-4484d5c5f7c60454b867dab13c2e9a34.png";